// FAQ Accordion functionality
let selectedCategory = "all";

document.querySelectorAll(".faq-question").forEach((question) => {
  question.addEventListener("click", () => {
    const currentAnswer = question.nextElementSibling;
    const currentIcon = question.querySelector("img");
    const isCurrentlyOpen = currentAnswer.classList.contains("open");

    // Close all answers with smooth transition and reset all icons to plus
    document.querySelectorAll(".faq-answer").forEach((answer) => {
      if (answer.classList.contains("open")) {
        answer.style.maxHeight = "0px";
        answer.classList.remove("open");
      }
    });

    document.querySelectorAll(".faq-question img").forEach((icon) => {
      icon.src = icon.src.replace("/minus-icon.svg", "/plus-icon.svg");
    });

    // Reset all questions to collapsed state
    document.querySelectorAll(".faq-question").forEach((q) => {
      q.setAttribute("aria-expanded", "false");
    });

    // If the clicked answer wasn't open, open it with smooth transition and change icon to minus
    if (!isCurrentlyOpen) {
      currentAnswer.classList.add("open");
      // Use setTimeout to ensure the class is applied before setting height
      setTimeout(() => {
        currentAnswer.style.maxHeight = currentAnswer.scrollHeight + 50 + "px";
      }, 10);
      question.setAttribute("aria-expanded", "true");
      currentIcon.src = currentIcon.src.replace(
        "/plus-icon.svg",
        "/minus-icon.svg"
      );
    }
  });
});

// FAQ Category filtering functionality
document.querySelectorAll(".faq-cat-heading").forEach((categoryHeading) => {
  categoryHeading.addEventListener("click", () => {
    selectedCategory = categoryHeading.dataset.category;
    const categoryText = categoryHeading.querySelector("h3").textContent;

    // Remove active class from all category headings (both desktop and mobile)
    document.querySelectorAll(".faq-cat-heading").forEach((heading) => {
      heading.classList.remove("active");
    });

    // Add active class to clicked heading and its counterpart
    document
      .querySelectorAll(`[data-category="${selectedCategory}"]`)
      .forEach((heading) => {
        if (heading.classList.contains("faq-cat-heading")) {
          heading.classList.add("active");
        }
      });

    // Update mobile dropdown text
    const dropdownText = document.querySelector(".faq-dropdown-text");
    if (dropdownText) {
      dropdownText.textContent = categoryText;
    }

    // Close mobile dropdown
    const dropdownMenu = document.querySelector(".faq-dropdown-menu");
    const dropdownToggle = document.querySelector(".faq-dropdown-toggle");
    if (dropdownMenu && dropdownToggle) {
      dropdownMenu.classList.remove("open");
      dropdownToggle.setAttribute("aria-expanded", "false");
    }

    // Close all open answers with smooth transition and reset icons when filtering
    document.querySelectorAll(".faq-answer").forEach((answer) => {
      if (answer.classList.contains("open")) {
        answer.style.maxHeight = "0px";
        answer.classList.remove("open");
      }
    });

    document.querySelectorAll(".faq-question img").forEach((icon) => {
      icon.src = icon.src.replace("/minus-icon.svg", "/plus-icon.svg");
    });

    document.querySelectorAll(".faq-question").forEach((q) => {
      q.setAttribute("aria-expanded", "false");
    });

    document.querySelectorAll(".faq-item").forEach((item) => {
      item.style.display = "none";
    });

    const allFaqItemsSelectedCategory = selectedCategory == 'all' ? document.querySelectorAll(".faq-item") : document.querySelectorAll(`.faq-item[data-category="${selectedCategory}"]`);

    // Show/hide FAQ items based on category
    allFaqItemsSelectedCategory.forEach((item, index) => {
      if (
        (selectedCategory === "all" ||
          item.dataset.category === selectedCategory) &&
        index < 6
      ) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });

	// get the number of items
	const totalItemsWithCategory = selectedCategory === "all"
	  ? document.querySelectorAll(".faq-item").length
	  : document.querySelectorAll(`.faq-item[data-category="${selectedCategory}"]`).length;

    // reset the show more button
    const showMoreBtn = document.querySelector(".faq-show-more-btn");

	if(showMoreBtn && totalItemsWithCategory < 7) {
		showMoreBtn.style.display = "none";
	}
	else {
		showMoreBtn.style.display = "inline-block";
	}

    if (showMoreBtn) {
      showMoreBtn.dataset.shown = "6";
	  showMoreBtn.dataset.total = totalItemsWithCategory;
    }
  });
});

// Mobile dropdown toggle functionality
document.querySelectorAll(".faq-dropdown-toggle").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const dropdownMenu = toggle.nextElementSibling;
    const isOpen = toggle.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      dropdownMenu.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");
    } else {
      dropdownMenu.classList.add("open");
      toggle.setAttribute("aria-expanded", "true");
    }
  });
});

// Close dropdown when clicking outside
document.addEventListener("click", (event) => {
  const dropdownContainer = event.target.closest(".faq-filter-mobile");
  if (!dropdownContainer) {
    document.querySelectorAll(".faq-dropdown-menu").forEach((menu) => {
      menu.classList.remove("open");
    });
    document.querySelectorAll(".faq-dropdown-toggle").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
  }
});

// FAQ Show More functionality
document.querySelectorAll(".faq-show-more-btn").forEach((showMoreBtn) => {
  showMoreBtn.addEventListener("click", () => {
	debugger;
    const currentShown = parseInt(showMoreBtn.dataset.shown);
    
    // Get all items that match the selected category
    const matchingItems = selectedCategory === "all" 
      ? Array.from(document.querySelectorAll(".faq-item"))
      : Array.from(document.querySelectorAll(`.faq-item[data-category="${selectedCategory}"]`));
    
    let visibleCount = 0;
    let nextItemsToShow = 0;
    
    // Count currently visible items and show next 6 matching items
    matchingItems.forEach((item) => {
      if (item.style.display !== "none" && !item.classList.contains("faq-hidden")) {
        visibleCount++;
      } else if (nextItemsToShow < 6) {
        item.style.display = "block";
		item.classList.remove("faq-hidden");
        nextItemsToShow++;
        visibleCount++;
      }
    });

    // Update the button's data attribute
    showMoreBtn.dataset.shown = visibleCount;

    // Hide button if all matching FAQs are shown
    if (visibleCount >= matchingItems.length) {
      showMoreBtn.style.display = "none";
    }

	if(window.innerScrollAnim) {
		window.innerScrollAnim.refresh();
	}
  });
});
